import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0131',
    ecrans: ['00-2']
});
